import React, { useState, useEffect } from 'react';
import { TrackableItemState } from '../api/api_pb';

interface StateEditModalProps {
    isOpen: boolean;
    onClose: () => void;
    currentState: TrackableItemState;
    currentName: string;
    onUpdate: (newState: TrackableItemState, newName: string) => void;
}

const stateOptions = [
    { value: TrackableItemState.READY, label: 'Ready' },
    { value: TrackableItemState.IN_USE, label: 'In Use' },
    { value: TrackableItemState.PENDING_INSTPECTION, label: 'Pending Inspection' },
    { value: TrackableItemState.RETURNED, label: 'Returned' },
];

const getSelectableStates = (currentState: TrackableItemState) => {
    switch (currentState) {
        case TrackableItemState.READY:
            return [TrackableItemState.READY, TrackableItemState.PENDING_INSTPECTION];
        case TrackableItemState.RETURNED:
            return [TrackableItemState.RETURNED, TrackableItemState.READY];
        case TrackableItemState.PENDING_INSTPECTION:
            return [TrackableItemState.PENDING_INSTPECTION, TrackableItemState.READY];
        case TrackableItemState.IN_USE:
            return [TrackableItemState.IN_USE, TrackableItemState.RETURNED];
        default:
            return [];
    }
};

const StateEditModal: React.FC<StateEditModalProps> = ({
    isOpen,
    onClose,
    currentState,
    currentName,
    onUpdate,
}) => {
    const [selectedState, setSelectedState] = useState<TrackableItemState>(currentState);
    const [name, setName] = useState<string>(currentName);


    useEffect(() => {
        setSelectedState(currentState);
        setName(currentName);
    }, [isOpen,currentName, currentState]);

    const selectableStates = getSelectableStates(currentState);

    const handleStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedState(parseInt(event.target.value, 10) as TrackableItemState);
    };

    const handleSubmit = () => {
        onUpdate(selectedState, name.trim());
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-1/3 max-w-lg">
                <h2 className="text-xl font-semibold mb-4">Edit Trackable Item</h2>
                 {/* Name Input */}
                 <div className="mb-4">
                    <label htmlFor="name-input" className="block text-gray-700 font-medium mb-2">
                    Trackable Item Name
                    </label>
                    <input
                        id="name-input"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        placeholder="Enter trackable item name"
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="state-select" className="block text-gray-700 font-medium mb-2">
                        Please select the state you want to switch to
                    </label>
                    <select
                        id="state-select"
                        value={selectedState}
                        onChange={handleStateChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    >
                        {stateOptions.map((state) => (
                            <option
                                key={state.value}
                                value={state.value}
                                disabled={!selectableStates.includes(state.value)}
                            >
                                {state.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="flex justify-end">
                    <button
                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md mr-2"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded-md"
                        onClick={handleSubmit}
                    >
                        Update
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StateEditModal;
